<template>
  <fieldset ref="dropzoneRef" class="relative inline-flex flex-col">
    <button
      v-if="!modelValue"
      type="button"
      :disabled="uploading"
      :class="[
        `relative grid place-items-center gap-1 overflow-hidden rounded border p-4 transition-colors`,
        !isDropping
          ? `border-border bg-input hover:bg-card active:bg-card`
          : `border-green-300 bg-green-100 dark:border-green-500/20 dark:bg-green-500/20`,
        `disabled:pointer-events-none disabled:opacity-100`,
      ]"
      @click="openFilePicker"
    >
      <PhotoIcon class="size-6 text-muted-foreground" />
      <div class="text-sm font-medium text-muted-foreground">
        Upload an image
      </div>
      <div class="text-muted-foreground/60 text-xs">PNG, JPG, or GIF</div>
    </button>
    <div
      v-else
      class="group/img relative self-end overflow-hidden rounded border border-border"
    >
      <img
        :src="modelValue"
        class="max-h-[200px] min-w-[200px] !max-w-[300px] bg-white"
      />

      <div
        class="absolute bottom-0 right-0 flex gap-2 p-4 opacity-0 transition-opacity group-focus-within/img:opacity-100 group-hover/img:opacity-100"
      >
        <Button @click="openFilePicker">
          <PencilIcon class="size-3" />
          <span>Change</span>
        </Button>

        <Button variant="negative" @click="modelValue = ''">
          <TrashIcon class="size-3" />
          <span>Remove</span>
        </Button>
      </div>
    </div>

    <div
      :class="[
        `pointer-events-none absolute inset-0 grid place-items-center bg-white/65 transition-opacity`,
        !uploading ? `opacity-0` : `opacity-100`,
      ]"
    >
      <ArrowPathIcon class="size-6 animate-spin" />
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import { ref } from "vue";

import Button from "@/components/Setting/Button.vue";
import { useSettingControl } from "@/components/Setting/context";
import ArrowPathIcon from "@/icons/heroicons/arrow-path-outline.svg";
import PencilIcon from "@/icons/heroicons/pencil-micro.svg";
import PhotoIcon from "@/icons/heroicons/photo-solid.svg";
import TrashIcon from "@/icons/heroicons/trash-micro.svg";

import { useImageDrop } from "./lib";

const modelValue = defineModel<string>({ default: "" });

const dropzoneRef = ref<HTMLElement | null>(null);
const { isDropping, openFilePicker, uploading } = useImageDrop({
  target: dropzoneRef,
  onSuccess(imageUrl) {
    modelValue.value = imageUrl;
  },
});

// Registering as multiple because there's multiple buttons here, not sure yet.
const setting = useSettingControl();
setting?.register({ multiple: true });
</script>
